exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".Interactive-List-item {\n  font-size: 14px;\n  line-height: 18px;\n  color: #484848;\n  margin-top: 5px;\n  margin-bottom: 5px;\n  cursor: pointer; }\n  .Interactive-List-item .item-content {\n    font-size: 12px;\n    display: inline-block;\n    width: 88%; }\n  .Interactive-List-item .price {\n    font-size: 15px;\n    margin: auto;\n    display: flex; }\n  .Interactive-List-item strong {\n    font-weight: 700; }\n  .Interactive-List-item i {\n    font-size: 8px;\n    vertical-align: bottom;\n    font-weight: 600;\n    opacity: 0.6; }\n  .Interactive-List-item:hover * {\n    opacity: 1; }\n", ""]);

// exports
